import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class DeleteLeverantorsorderCommand extends BasicCommand<DeleteLeverantorsorderCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<DeleteLeverantorsorderCommand>;
    leverantorsorderId: number;
    constructor(leverantorsorderId: number) {
        super("DeleteLeverantorsorderCommand", "leverantorsorderrad", CommandType.Delete);
        this.leverantorsorderId = leverantorsorderId;
    }
}
